<div class="discipline-web">
  <app-page-title titleKey="discipline.title"></app-page-title>

  <!-- Children Selection Buttons -->
  
  <app-children-selector [(selectedStudentId)]="selectedStudentId" (studentSelected)="onStudentSelected($event)"></app-children-selector>
<app-loader *ngIf="loading"></app-loader>
  <!-- Tab Navigation -->
  <div class="tab-menu-heading hremp-tabs p-0 border-0">
    <div class="tabs-menu1">
      <ul class="panel-tabs">
        <div class="tab-button" [class.active]="activeTab === 'discipline'" (click)="setActiveTab('discipline')">
          <span>{{ 'discipline.disciplineTab' | translate }}</span>
        </div>
        <div class="tab-button" [class.active]="activeTab === 'punition'" (click)="setActiveTab('punition')">
          <span>{{ 'discipline.punitionTab' | translate }}</span>
        </div>
      </ul>
    </div>
    <div *ngIf="!loading">
    <!-- Tab Content -->
    <div class="panel-body tabs-menu-body hremp-tabs1 p-0"> 
      <!-- Discipline Table -->
      <div *ngIf="activeTab === 'discipline'" class="table-container">
        <div class="table-header">
          <h3>{{ 'discipline.discipline' | translate }} {{selectedChild}}</h3>
          <div class="search-container">
            <input 
              type="text" 
              pInputText 
              [placeholder]="'discipline.searchPlaceholder' | translate" 
              (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
              class="search-input"
            />
          </div>
        </div>



<!-- Discipline Table -->
<p-table 
  [value]="filteredDisciplineRecords" 
  [globalFilterFields]="['type', 'nameMatiere', 'dateFlag', 'horaire', 'nameTeacher']"
  #dt1
  [rows]="5"
  [showCurrentPageReport]="true"
  [currentPageReportTemplate]="'discipline.pagination.showing' | translate"
  styleClass="p-datatable-striped"
>
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'discipline.tableHeaders.dateTime' | translate }}</th>
              <th>{{ 'discipline.tableHeaders.type' | translate }}</th>
              <th>{{ 'discipline.tableHeaders.subject' | translate }}</th>
              <th>{{ 'discipline.tableHeaders.teacher' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-discipline>
            <tr>
              <td>
                {{ formatDateShort(discipline.dateFlag) }}
                <ng-container *ngIf="discipline.horaire && formatHoraireHour(discipline.horaire) !== '-'">
                  &nbsp;à&nbsp;{{ formatHoraireHour(discipline.horaire) }}
                </ng-container>
              </td>
              <td>{{discipline.type || '-'}}</td>
              <td>{{discipline.nameMatiere || '-'}}</td>
              <td>{{discipline.nameTeacher || '-'}}</td>
            </tr>
          </ng-template>
        </p-table>



      </div>

      <!-- Punition Table -->
      <div *ngIf="activeTab === 'punition'" class="table-container">
        <div class="table-header">
          <h3>{{ 'discipline.punition' | translate }} {{selectedChild}}</h3>
          <div class="search-container">
            <input 
               type="text" 
               pInputText 
               [placeholder]="'discipline.searchPlaceholder' | translate" 
               (input)="dt2.filterGlobal($any($event.target).value, 'contains')"
               class="search-input"
             />
          </div>
        </div>



<!-- Punition Table -->
<p-table 
  [value]="punitionRecords" 
  [globalFilterFields]="['name', 'matiere', 'nameTeacher', 'punishementDescription', 'creationDate', 'horaire']"
  #dt2
  [rows]="5"
  [showCurrentPageReport]="true"
  [currentPageReportTemplate]="'discipline.pagination.showing' | translate"
  styleClass="p-datatable-striped"
>
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'discipline.tableHeaders.dateTime' | translate }}</th>
              <th>{{ 'discipline.tableHeaders.name' | translate }}</th>
              <th>{{ 'discipline.tableHeaders.subject' | translate }}</th>
              <th>{{ 'discipline.tableHeaders.teacher' | translate }}</th>
              <th>{{ 'discipline.tableHeaders.description' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-punition>
            <tr>
              <td>
                {{ formatDateShort(punition.creationDate) }}
                <ng-container *ngIf="punition.horaire && formatHoraireHour(punition.horaire) !== '-'">
                  &nbsp;à&nbsp;{{ formatHoraireHour(punition.horaire) }}
                </ng-container>
              </td>
              <td>{{punition.name || '-'}}</td>
              <td>{{punition.matiere || '-'}}</td>
              <td>{{punition.nameTeacher || '-'}}</td>
              <td>{{punition.punishementDescription || '-'}}</td>
            </tr>
          </ng-template>
        </p-table>

      </div>
    </div>
  </div>
</div></div>